import {AxiosInstance} from "axios";
import HelpRequest from "../model/help/HelpRequest";

/**
 * Api for help request.
 */
export default class HelpApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	/**
	 * Create help request
	 * @param {HelpRequest} data help request data.
	 * @return {Promise<void>}
	 */
	createHelpRequest(data: HelpRequest): Promise<void> {
		const url = `/api/web/help_request`;
		return this.axiosInstance.post(url, data.toJson()).then(() => {});
	}
}